import "core-js/modules/web.dom-collections.iterator.js";
import React, { useState } from 'react';
import { Field } from 'react-final-form';
import { RadioButtons } from '@eika/radio-button';
import { AnswerType, YesNoAnswer } from '../generated-types';
import HelpModal from '../util/helpModals/help-modal';
import { requiredField } from '../util/validator';
import OverrideLabel from './override-label';
import { SubQuestionRenderer } from './sub-question-renderer';
const YesNoQuestionType = _ref => {
  let {
    question,
    name,
    countries,
    setValueOfField,
    setInitialValueOfSpecialFields,
    renderLabelAsHtml = false
  } = _ref;
  const [selected, setSelected] = useState('');
  const options = [{
    value: YesNoAnswer.YES,
    label: 'Ja',
    id: "".concat(name, "_id_for_yes")
  }, {
    value: YesNoAnswer.NO,
    label: 'Nei',
    id: "".concat(name, "_id_for_no")
  }];
  const shouldRenderSubQuestions = question => {
    var _question$showSubQues;
    return ((_question$showSubQues = question.showSubQuestionsCondition) === null || _question$showSubQues === void 0 ? void 0 : _question$showSubQues.typeInfo) === 'OnYes' && selected === YesNoAnswer.YES;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Field, {
    name: name,
    validate: requiredField,
    render: _ref2 => {
      var _meta$error;
      let {
        input,
        meta
      } = _ref2;
      return /*#__PURE__*/React.createElement("div", {
        className: "radioknobs"
      }, renderLabelAsHtml && /*#__PURE__*/React.createElement("span", {
        className: "sgw-radio-button-legend yes-no-radio-label-margin-override"
      }, /*#__PURE__*/React.createElement(OverrideLabel, {
        text: question.text,
        infoButton: /*#__PURE__*/React.createElement(HelpModal, {
          helpText: question.helpText,
          questionId: question.id
        }),
        extraClass: "sgw-radio-button-legend-text"
      })), /*#__PURE__*/React.createElement(RadioButtons, {
        onChange: value => {
          setSelected(value);
          return input.onChange({
            answer: value,
            questionId: question.id,
            questionVersion: question.version,
            answerType: AnswerType.YES_NO
          });
        },
        options: options,
        selectedOption: selected,
        horizontal: true,
        label: !renderLabelAsHtml ? question.text : '',
        errorMessage: selected === '' && meta.touched && meta.error ? (_meta$error = meta.error) !== null && _meta$error !== void 0 ? _meta$error : 'Velg ett alternativ' : '',
        name: name,
        id: "".concat(name, "_id")
      }));
    }
  }), question.subQuestions && shouldRenderSubQuestions(question) ? /*#__PURE__*/React.createElement("div", {
    className: "sub-questions-wrapper"
  }, question.subQuestions.map((subQuestion, index) => {
    return /*#__PURE__*/React.createElement("div", {
      className: "input-field",
      key: subQuestion.id
    }, /*#__PURE__*/React.createElement(SubQuestionRenderer, {
      subQuestion: subQuestion,
      index: index,
      name: name,
      setValueOfField: setValueOfField,
      countries: countries,
      setInitialValueOfSpecialFields: setInitialValueOfSpecialFields,
      validate: requiredField
    }));
  })) : undefined);
};
export default YesNoQuestionType;